import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { TRICOLOR } from './PageSection';

// Shared hero band for every dedicated page: deep petrol, closed by the
// tricolor logo bar. Sits under the fixed header (hence the top padding).
const HeroSection = styled(Box)(({ theme }) => ({
  position: 'relative',
  backgroundColor: '#00425c',
  backgroundImage:
    'radial-gradient(circle at 80% 15%, rgba(128,172,192,0.20), transparent 40%), radial-gradient(circle at 12% 30%, rgba(134,163,21,0.18), transparent 40%), radial-gradient(circle at 88% 85%, rgba(193,10,39,0.12), transparent 45%), linear-gradient(165deg, #05537000 0%, rgba(2,49,68,0.55) 100%)',
  color: '#ffffff',
  padding: '175px 0 80px',
  textAlign: 'center',
  overflow: 'hidden',
  '&:after': {
    content: '""',
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    height: '4px',
    backgroundImage: TRICOLOR,
  },
  [theme.breakpoints.down('md')]: {
    padding: '125px 0 56px',
  },
}));

const Kicker = styled(Typography)(({ theme }) => ({
  color: '#8fc1d6',
  fontFamily: '"Sora", sans-serif',
  fontSize: '13px',
  fontWeight: 700,
  letterSpacing: '2.5px',
  textTransform: 'uppercase',
  marginBottom: '16px',
}));

const Title = styled(Typography)(({ theme }) => ({
  color: '#ffffff',
  maxWidth: '860px',
  margin: '0 auto',
}));

const Subtitle = styled(Typography)(({ theme }) => ({
  color: 'rgba(255,255,255,0.80)',
  fontSize: '17px',
  lineHeight: 1.75,
  maxWidth: '740px',
  margin: '20px auto 0',
  [theme.breakpoints.down('md')]: { fontSize: '15.5px' },
}));

function PageHero({ kicker, title, subtitle }) {
  return (
    <HeroSection>
      <Container maxWidth="lg">
        {kicker && <Kicker>{kicker}</Kicker>}
        <Title variant="h1">{title}</Title>
        {subtitle && <Subtitle>{subtitle}</Subtitle>}
      </Container>
    </HeroSection>
  );
}

export default PageHero;
